import React from 'react';
import { Mail, Linkedin, Instagram } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="section-padding-small" style={{ background: '#fffef2', borderTop: '1px solid rgba(51,51,51,0.1)' }}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_elite-properties-18/artifacts/69sbmjqc_MaisonEze.png" 
              alt="Maison Eze" 
              className="h-16 mb-4"
            />
            <p className="body-small" style={{ color: '#666666', lineHeight: 1.6 }}>
              {t.footer.description}
            </p>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="body-regular mb-4" style={{ color: '#333333', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '14px' }}>
              {t.footer.contactTitle}
            </h4>
            <a 
              href="mailto:contact@maison-eze.com" 
              className="body-small flex items-center gap-2 mb-3 transition-colors hover:text-gray-900"
              style={{ color: '#666666', textDecoration: 'none' }}
            >
              <Mail className="w-4 h-4" style={{ color: '#C9A961' }} />
              contact@maison-eze.com
            </a>
            <a 
              href="https://wa.me/33621371677" 
              target="_blank"
              rel="noopener noreferrer"
              className="body-small flex items-center gap-2 mb-3 transition-colors hover:text-gray-900"
              style={{ color: '#666666', textDecoration: 'none' }}
            >
              <svg className="w-4 h-4" style={{ color: '#C9A961' }} fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Mobile WhatsApp: +33 6 21 37 16 77
            </a>
            <a 
              href="tel:+306993367855" 
              className="body-small flex items-center gap-2 mb-3 transition-colors hover:text-gray-900"
              style={{ color: '#666666', textDecoration: 'none' }}
            >
              <svg className="w-4 h-4" style={{ color: '#C9A961' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              Greek Mobile: +30 699 336 7855
            </a>
            <div className="body-small flex items-center gap-2 mb-3" style={{ color: '#666666' }}>
              <svg className="w-4 h-4" style={{ color: '#C9A961' }} fill="currentColor" viewBox="0 0 24 24">
                <path d="M8.691 2.188C7.88 2.188 7.208 2.86 7.208 3.67v16.66c0 .81.672 1.482 1.483 1.482h6.618c.81 0 1.483-.672 1.483-1.482V3.67c0-.81-.673-1.482-1.483-1.482H8.691zm.331 1.637h5.956a.244.244 0 01.244.244v13.3a.244.244 0 01-.244.244H9.022a.244.244 0 01-.244-.244V4.07a.244.244 0 01.244-.244zm2.978 14.83a.98.98 0 100 1.96.98.98 0 000-1.96z"/>
              </svg>
              WeChat ID: maison-eze
            </div>
          </div>
          
          {/* Social */}
          <div>
            <h4 className="body-regular mb-4" style={{ color: '#333333', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '14px' }}>
              {t.footer.followTitle}
            </h4>
            <div className="flex gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center transition-all hover:bg-gray-100"
                style={{ border: '1px solid rgba(51,51,51,0.2)', borderRadius: '0px' }}
              >
                <Linkedin className="w-5 h-5" style={{ color: '#C9A961' }} />
              </a>
              <a 
                href="https://www.instagram.com/maison.eze/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center transition-all hover:bg-gray-100"
                style={{ border: '1px solid rgba(51,51,51,0.2)', borderRadius: '0px' }}
              >
                <Instagram className="w-5 h-5" style={{ color: '#C9A961' }} />
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="pt-8 border-t text-center" style={{ borderColor: 'rgba(51,51,51,0.1)' }}>
          <p className="body-small" style={{ color: '#666666' }}>
            © {new Date().getFullYear()} {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;